"use client"

import { useSessionProbe } from "@/platform/session/use-session"

export const SessionProbe = () => {
  useSessionProbe()
  return null
}
